var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "world-map" }, [
    _vm.mapData.type == "map" && _vm.isMapCreated
      ? _c("div", { staticClass: "map_legend" }, [
          _vm.mapHasData
            ? _c(
                "div",
                { staticClass: "legend_group first" },
                _vm._l(_vm.legendItems, function(item, itemKey) {
                  return _c("div", { staticClass: "legend_item" }, [
                    _c("div", {
                      staticClass: "item_chip",
                      style: { backgroundColor: item.color }
                    }),
                    itemKey + 1 < _vm.legendItems.length
                      ? _c("div", { staticClass: "item_label" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                item.lowerBound + " - " + item.upperBound
                              ) +
                              "\n                "
                          )
                        ])
                      : _c("div", { staticClass: "item_label" }, [
                          _vm._v(
                            "\n                    > " +
                              _vm._s(item.lowerBound) +
                              "\n                "
                          )
                        ])
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.hasTaxHavensData
            ? _c(
                "div",
                {
                  staticClass: "legend_group",
                  class: _vm.mapHasData ? "" : "first"
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "legend_group",
              class: _vm.hasTaxHavensData ? "last" : ""
            },
            [_vm._m(1)]
          )
        ])
      : _vm.mapData.type == "bubbles" && _vm.isMapCreated
      ? _c("div", { staticClass: "map_legend" }, [
          _vm._m(2),
          _vm.hasTaxHavensData
            ? _c("div", { staticClass: "legend_group" }, [_vm._m(3)])
            : _vm._e()
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "svg_container",
        style: { width: _vm.fitWidth + "px", height: _vm.fitHeight + "px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "loader lds-ellipsis",
            class: _vm.loaderDisplayed ? "displayed" : ""
          },
          [_c("div"), _c("div"), _c("div"), _c("div")]
        ),
        _c("svg", {
          ref: "svg",
          attrs: {
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 " + _vm.fitWidth + " " + _vm.fitHeight
          }
        }),
        _c(
          "div",
          {
            ref: "tooltip",
            staticClass: "tooltip",
            staticStyle: {
              position: "absolute",
              display: "none",
              "pointer-events": "none"
            },
            attrs: { "data-clickable": _vm.isTooltipClickable }
          },
          [
            _c("p", { ref: "tooltipCountry", staticClass: "tooltip_country" }),
            _c("p", { staticClass: "tooltip_value" }, [
              _c("span", {
                ref: "tooltipValueChip",
                staticClass: "tooltip_value_chip"
              }),
              _c("span", {
                ref: "tooltipValueNumber",
                staticClass: "tooltip_value_number"
              })
            ]),
            _c("p", { staticClass: "tooltip_click" }, [
              _vm._v("Click to learn more")
            ])
          ]
        )
      ]
    ),
    _vm.hasTimeline
      ? _c(
          "div",
          {
            staticClass: "app_timeline map_timeline",
            attrs: { "data-isplaying": _vm.isPlaying }
          },
          [
            _c("button", {
              staticClass: "timeline_bt",
              on: { click: _vm.togglePlay }
            }),
            _c("div", { staticClass: "timeline_year" }, [
              _vm._v(_vm._s(_vm.currentYear))
            ]),
            _c("v-slider", {
              staticClass: "timeline_slider",
              attrs: { min: _vm.minYear, max: _vm.maxYear },
              on: { start: _vm.dragStart, end: _vm.dragEnd },
              model: {
                value: _vm.currentYear,
                callback: function($$v) {
                  _vm.currentYear = $$v
                },
                expression: "currentYear"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend_item" }, [
      _c("div", { staticClass: "item_chip", attrs: { "data-bg": "orange" } }),
      _c("div", { staticClass: "item_label" }, [_vm._v("Tax havens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend_item" }, [
      _c("div", { staticClass: "item_chip", attrs: { "data-bg": "white" } }),
      _c("div", { staticClass: "item_label" }, [_vm._v("No data")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend_group first" }, [
      _c("div", { staticClass: "legend_item" }, [
        _c("div", { staticClass: "item_chip", attrs: { "data-bg": "orange" } }),
        _c("div", { staticClass: "item_label" }, [_vm._v("Tax havens")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend_item" }, [
      _c("div", { staticClass: "item_chip", attrs: { "data-bg": "light" } }),
      _c("div", { staticClass: "item_label" }, [_vm._v("Non-tax havens")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345f6a67", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345f6a67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mapChoropleth.vue
// module id = MBCq
// module chunks = 0 1